import { type State } from 'app/common/ui-components/filter'

import { flags as details } from 'app/components/common/reports/filters/details'
import { flags as org } from 'app/components/common/reports/filters/org'
import { flags as customerType } from 'app/components/common/reports/filters/customerType'

import { flags as group } from '../group'

export const isPayerDataVisibleActivity = (state: State) => {
  return (
    details.detailsChecked(state) &&
    org.singleOrgSelected(state) &&
    customerType.onlyStudentCustomerSelected(state) &&
    group.isActive(state) &&
    group.byUsersSelected(state)
  )
}
